import req, { get, post, put, del } from '@/utils/request'
import type { ApiResponse } from '@/types'

export interface LLMConfigItem {
  id: number
  provider: string
  base_url: string
  api_key: string
  api_secret: string
  model_name: string
  max_tokens: number
  temperature: number
  top_p: number
  is_active: boolean
  system_prompt: string
  extra_config: string
  description: string
  last_test_at: string | null
  last_test_result: string
  create_time: string
  update_time: string
}

export interface LLMConfigFormData {
  provider: string
  base_url: string
  api_key: string
  api_secret: string
  model_name: string
  max_tokens: number
  temperature: number
  top_p: number
  system_prompt: string
  extra_config: string
  description: string
}

/** 获取当前启用的配置 */
export function getActiveConfig() {
  return get<LLMConfigItem>('/llm-config/active')
}

/** 获取所有配置列表 */
export function listConfigs() {
  return get<LLMConfigItem[]>('/llm-config/')
}

/** 获取单个配置 */
export function getConfig(id: number) {
  return get<LLMConfigItem>(`/llm-config/${id}`)
}

/** 创建配置 */
export function createConfig(data: LLMConfigFormData) {
  return post<LLMConfigItem>('/llm-config/', data)
}

/** 更新配置 */
export function updateConfig(id: number, data: Partial<LLMConfigFormData> & { is_active?: boolean }) {
  return put<LLMConfigItem>(`/llm-config/${id}`, data)
}

/** 删除配置 */
export function deleteConfig(id: number) {
  return del(`/llm-config/${id}`)
}

/** 测试连接 - 返回完整响应，前端直接使用后端 message */
export async function testConnection(id: number) {
  const res = await req.post(`/llm-config/${id}/test`)
  return res.data as ApiResponse<{ reply: string; model: string; provider: string }>
}

/** 从提供商 API 获取可用模型列表（用表单中明文 Key，适用于新增/改 Key 场景） */
export function fetchModels(payload: { provider: string; base_url: string; api_key: string }) {
  return post<string[]>('/llm-config/models', payload)
}

/** 用已保存密钥获取模型列表（编辑时表单 Key 为脱敏值，走后端库内密钥，不出库） */
export function fetchModelsSaved(id: number, payload: { base_url?: string }) {
  return post<string[]>(`/llm-config/${id}/models`, payload)
}
